import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FONTS from '@mlb/react-patterns/style/fonts';
import ModalPattern from '@mlb/react-patterns/components/AnimatedModal/animatedModal.tsx';
import { ContentWrapper } from '@mlb/react-patterns/components/AnimatedModal/animatedModal.style.tsx';

import { useDictionary } from '../../hooks/config';
import { useKeyPress } from '../../hooks';
import { keyConstants } from '../../utils';
import Url from './Url';
import EmbedCode from './EmbedCode';
import SocialList from './SocialList';

const { TAB } = keyConstants;
const keysToTrack = [TAB];

export const Modal = styled(ModalPattern)`
    &&& {
        height: auto;
        top: 50%;
        left: 50%;
        border-radius: 6px;
        transform: translate(-50%, -50%);
        font-family: ${FONTS.primaryFont};
        ${ContentWrapper} {
            padding: 12px 20px;
        }
    }
`;

const FallbackModal = ({
    link,
    onClosed,
    isOpen,
    mediaPlayback,
    onShare,
}) => {

    const dictionary = useDictionary();
    const firstFocusedNode = React.useRef(null);
    const firstModalNode = React.useRef(null);
    const lastModalNode = React.useRef(null);
    const keyPressCallbackProps = {
        cb: (event) => {

            if (event.target === lastModalNode.current) {

                event.preventDefault();
                firstModalNode.current.focus();

            }

        },
        shiftCB: (event) => {

            if (event.target === firstModalNode.current) {

                event.preventDefault();
                lastModalNode.current.focus();

            }

        },
    };
    const { share_video_text = 'Share this Video' } = dictionary;

    useKeyPress(keysToTrack, keyPressCallbackProps);

    return (
        <Modal
            open={isOpen}
            closeButtonRef={firstModalNode}
            headerTitle={share_video_text}
            width={'320px'}
            overlay={true}
            handlers={{
                onOpened: () => {

                    firstFocusedNode.current.firstElementChild.focus();

                },
                onClosed,
            }}
            closeButtonRight={true}
        >
            <SocialList
                firstFocusedNode={firstFocusedNode}
                mediaPlayback={mediaPlayback}
                link={link}
                onShare={onShare}
            />
            <Url
                link={link}
                onShare={onShare}
            />
            <EmbedCode
                lastModalNode={lastModalNode}
                mediaPlayback={mediaPlayback}
                onShare={onShare}
            />
        </Modal>
    );

};

FallbackModal.propTypes = {
    link: PropTypes.string.isRequired,
    onClosed: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onShare: PropTypes.func.isRequired,
    mediaPlayback: PropTypes.object,
};

FallbackModal.defaultProps = {
    mediaPlayback: {},
};

export default FallbackModal;
